import { yupResolver } from "@hookform/resolvers/yup"
import {
  Accordion,
  Avatar,
  Button,
  FileInput,
  Group,
  Input,
  LoadingOverlay,
  Radio,
  Select,
  Tabs,
  TextInput,
} from "@mantine/core"
import { useDisclosure, useId } from "@mantine/hooks"
import {
  IconArchive,
  IconArrowBackUp,
  IconBrandTelegram,
  IconDeviceFloppy,
  IconTrash,
  IconUser,
} from "@tabler/icons-react"
import { useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { debounce } from "lodash-es"
import InputMask from "react-input-mask"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import * as yup from "yup"
import ActivityLogWrapperComponent from "../../../shared/component/ActivityLog/activityLog-wrapper-component"
import Confirmation from "../../../shared/component/confirmation/action-confirmation"
import EmptyIcon from "../../../shared/component/empty-icon/empty-icon"
import { Constants } from "../../../shared/constants/Constants"
import { useLazyGetActivitiesQuery } from "../../../shared/store/query/sharedQuery"
import {
  downloadUrlParser,
  parsePhoneNumber,
} from "../../../shared/utility/Tools/tools"
import countryCodes from "../../../shared/utility/countryCodes.json"

import { Tenant } from "../../../models/tenant.model"
import {
  getCitiesByCountry,
  getUniqueCountryOptions,
  worldCities,
} from "../../../shared/utility/world-cities"
import {
  useArchiveTenantMutation,
  useCreateTenantMutation,
  useDeleteTenantMutation,
  useLazyGetArchivedTenantQuery,
  useLazyGetOwnersOfTenantQuery,
  useLazyGetTenantQuery,
  useRestoreTenantMutation,
  useToggleTenantStatusMutation,
  useUpdateTenantMutation,
} from "../store/tenant.query"
import { CollectionQuery } from "../../../models/collection.model"
import { Owner } from "../../../models/owner.model"
import PushNotificationComponent from "../../../shared/component/push-notification/component/push-notification.component"
import ExportModalComponent from "../../../shared/component/export-modal/component/export-modal.component"
import { exportTenants } from "../api/tenant.api"
import ImportTenantComponent from "./import-tenant-component"
import { IconUpload } from "@tabler/icons-react"
import { onViewFile } from "../../../shared/utility/view-file"
import { useTranslation } from "react-i18next"
import FileViewerModal from "../../../shared/component/file-viewer/file-viewer-modal.component"
import { flexiblePhoneRegEx } from "../../../shared/utility/Tools/RegEx"

// import OwnerFileUploadComponent from "./owner-file-upload.component";

interface Props {
  editMode: string
}

export default function NewTenantComponent(props: Props) {
  const { editMode } = props
  const id = useId()
  const { t } = useTranslation()
  const params = useParams()
  const location = useLocation()
  const [logo, setLogo] = useState<any>()
  const [emergencyCode, setEmergencyCode] = useState("+251")
  const currentUser: any = JSON.parse(
    localStorage.getItem("userInfo") as string,
  )
  const [opened, { open, close }] = useDisclosure()
  let schema: any = yup.object().shape({
    name: yup
      .string()
      .min(2, t("nameMin", { count: 2 }))
      .max(100, t("nameMax", { count: 100 }))
      .required(t("nameRequired")),
    email: yup.string().nullable().email(t("validEmail")),
    // .required("Email is required"),
    phoneNumber: yup
      .string()
      .required(t("phoneRequired"))
      .matches(flexiblePhoneRegEx, t("validPhone")),
    gender: yup.string().nullable(),
    // .required(t("genderRequired")),
    ownerId: yup.string().when([], (ownerId: any, schema: any) => {
      if (currentUser?.role?.key && currentUser?.role?.key == "super_admin") {
        return schema.typeError(t("ownerString")).required(t("ownerRequired"))
      } else {
        return schema.nullable()
      }
    }),

    address: yup.object().shape({
      country: yup.string(),
      // .required("Country is required"),
      city: yup.string(),
      // .required("City is required"),
      subCity: yup.string(),
      woreda: yup.string(),
      houseNumber: yup.string(),
      // .required("House Number is required"),
    }),
    // .required("Address is required"),

    // emergencyContact: yup.object().shape({
    //   name: yup
    //     .string()
    //     .min(2, t("nameMin", { count: 2 }))
    //     .max(100, t("nameMax", { count: 100 }))
    //     .required(t("nameRequired")),
    //   phoneNumber: yup
    //     .string()
    //     .required(t("phoneRequired"))
    //     .matches(
    //       flexiblePhoneRegEx,
    //       t("validPhone"),
    //     ),
    // }),
    // identification: yup.mixed().when([], (boloDueDate: any, schema: any) => {
    //   if (editMode == "new" && !tenant?.data?.identification) {
    //     return schema
    //       .nullable()
    //       // .required(t("identificationRequired"))
    //       .test(
    //         "fileSize",
    //         t("identificationSize", { size: "2MB" }),
    //         (value: any) => {
    //           return value && value?.size <= 2000000
    //         },
    //       )
    //       .test("type", t("identificationType"), (value: any) => {
    //         return (
    //           (value && value?.type === "image/jpg") ||
    //           value?.type === "image/jpeg" ||
    //           value?.type === "image/png"
    //         )
    //       })
    //   }
    //   return schema.nullable()
    // }),
  })

  const defaultValue: Tenant = {
    id: "",
    name: "",
    email: "",
    phoneNumber: "",
    gender: "",
    address: {
      country: "",
      city: "",
      subCity: "",
      woreda: "",
      houseNumber: "",
    },
    emergencyContact: {
      name: "",
      phoneNumber: "",
    },
    archiveReason: "",
    createdBy: "",
    updatedBy: "",
    deletedBy: "",
    minioProfileImage: "",
  }

  const [getTenant, tenant] = useLazyGetTenantQuery()
  const [createTenant, newTenant] = useCreateTenantMutation()
  const [updateTenant, updateResponse] = useUpdateTenantMutation()
  const [restoreTenant, restoredTenant] = useRestoreTenantMutation()
  const [deleteTenant, deleteResponse] = useDeleteTenantMutation()
  const [getActivities, activities] = useLazyGetActivitiesQuery()
  const [archiveTenant, archiveResponse] = useArchiveTenantMutation()
  const [toggleStatus, toggleStatusResponse] = useToggleTenantStatusMutation()
  const [getArchivedTenant, archivedTenant] = useLazyGetArchivedTenantQuery()
  const [getOwners, owners] = useLazyGetOwnersOfTenantQuery()

  const [fileOpened, { open: fileOpen, close: fileClose }] = useDisclosure()
  const [selectedFile, setSelectedFile] = useState<string[]>([])
  const {
    register,
    setValue,
    getValues,
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<Tenant>({
    resolver: yupResolver(schema),
    mode: "all",
  })

  let selectedCountry = watch("address.country")

  const navigate = useNavigate()

  const [userId, setUserId] = useState("")
  const [code, setCode] = useState("+251")
  const [data] = useState<any>(countryCodes)
  const [citySelection, setCitySelection] = useState<string>("")

  const [isCompanyClicked, setIsCompanyClicked] = useState<boolean>(false)

  const [ownerSearch, setOwnerSearch] = useState<string | null>(null)
  const [ownersCollection, setOwnersCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
  })

  useEffect(() => {
    if (editMode === "detail") {
      if (params?.type && params?.type === "archived") {
        getArchivedTenant(`${params?.id}`).then((response: any) => {
          setLogo(response.data.logo)
          setIsCompanyClicked(response.data?.isCompany)
          reset(response.data)
          setUserId(response.data.id)
        })
      } else {
        getTenant(`${params?.id}`).then((response: any) => {
          setLogo(response.data.logo)
          // setIsCompanyClicked(response.data?.isCompany);
          reset(response.data)
          setUserId(response?.data?.id as string)
          // setValue('phoneNumber', response?.data?.phoneNumber as string)
          setValue("gender", response?.data?.gender as string)
          setValue("identification", null)
          // setValue('emergencyContact.phoneNumber', response?.data?.emergencyContact?.phoneNumber as string)
        })
      }
    } else {
      reset(defaultValue)
      setIsCompanyClicked(false)
    }
  }, [params, editMode, getTenant])

  useEffect(() => {
    getOwners({
      ...ownersCollection,
      filter: [[{ field: "name", operator: "like", value: ownerSearch }]],
    })
  }, [ownerSearch])
  useEffect(() => {
    getOwners(ownersCollection)
  }, [ownersCollection])

  // useEffect(() => {
  //   if (isCompanyClicked) {
  //     setValue("gender", "");
  //   }
  // }, [isCompanyClicked, setValue]);

  function onSubmit(data: any) {
    try {
      const formData = new FormData()

      if (currentUser?.role?.key != "super_admin") {
        formData.append("ownerId", currentUser?.id as string)
      } else {
        formData.append("ownerId", data?.ownerId as string)
      }
      // formData.append("id", data?.id as string);
      formData.append("name", data?.name as string)
      formData.append("email", data?.email as string)
      formData.append("phoneNumber", parsePhoneNumber(data.phoneNumber))
      formData.append("tinNumber", data?.tinNumber as string)
      data.gender && formData.append("gender", data?.gender as string)
      formData.append("address[country]", data?.address?.country as string)
      formData.append("address[city]", data?.address.city as string)
      formData.append("address[subCity]", data?.address?.subCity as string)
      formData.append("address[woreda]", data?.address?.woreda as string)
      formData.append(
        "address[houseNumber]",
        data?.address?.houseNumber as string,
      )
      formData.append(
        "emergencyContact[name]",
        data?.emergencyContact.name as string,
      )
      data?.emergencyContact?.phoneNumber &&
        formData.append(
          "emergencyContact[phoneNumber]",
          parsePhoneNumber(data?.emergencyContact?.phoneNumber) as string,
        )
      if (data.identification) {
        formData.append("identification", data.identification)
      }
      if (data.document) {
        data?.document?.forEach((doc: File) => {
          formData.append("documents", doc)
        })
      }

      if (editMode === "new") {
        createTenant(formData).then((response: any) => {
          if (!response?.error) {
            reset(defaultValue)
          }
        })
      } else {
        // const tenant: Tenant = {
        //   id: params.id,
        //   ...data,
        //   phoneNumber: data.phoneNumber.split(" ").join(""),
        // };
        formData.append("id", params?.id as string)
        updateTenant(formData)
      }
    } catch (e: any) {
      console.log("🚀 ~ onSubmit ~ e:", e)
    }
  }
  const onError = (error: any) => {
    console.log("🚀 ~ onError ~ error:", error)
  }

  function _parsePropertyOwners() {
    let data: { label: string; value: string }[] = []

    owners?.data?.data?.map((owner: Owner) => {
      data.push({ label: owner?.name as string, value: owner?.id as string })
    })

    return data
  }

  return (
    // <div className="h-full relative w-full dark:bg-gray-700 dark:text-white flex space-x-2 justify-center">
    <ActivityLogWrapperComponent
      title={
        editMode === "new" ? (
          t("newTenant")
        ) : (
          <div className="h-full space-x-2 flex flex-col sm:flex-row items-center">
            {logo && (
              <>
                <Avatar
                  src={downloadUrlParser({
                    path: logo?.path,
                    filename: logo?.filename,
                    originalname: logo?.originalname,
                    mimetype: logo?.mimetype,
                  })}
                  alt="photo"
                />
              </>
            )}

            <div>{tenant?.data?.name}</div>

            <Button
              classNames={{ label: "flex space-x-1 " }}
              variant="default"
              className="bg-primary text-white"
              type="button"
              size="xs"
              onClick={() => {
                open()
              }}
            >
              <IconBrandTelegram />
              <span>{t("sendNotification")}</span>
            </Button>
          </div>
        )
      }
      item={tenant}
      path={`/tenant/detail/${params?.type}/${params.id}`}
      id={params.id ?? ""}
    >
      <LoadingOverlay
        visible={
          (editMode === "new"
            ? newTenant.isLoading
            : updateResponse.isLoading) || tenant.isLoading
        }
      />
      <>
        <Tabs defaultValue="tenant">
          <Tabs.List>
            <Tabs.Tab value="tenant" icon={<IconUser size={14} />}>
              {t("basicTenantInfo")}
            </Tabs.Tab>
            {/* {editMode === "detail" && (
                <Tabs.Tab value="document" icon={<IconFilePlus size={14} />}>
                  Upload document
                </Tabs.Tab>
              )} */}
          </Tabs.List>

          <Tabs.Panel value="tenant" pt="xs">
            <div className="flex  justify-center h-full">
              <form
                onSubmit={handleSubmit(onSubmit, onError)}
                className="w-full gap-y-4 dark:text-white"
              >
                <Accordion
                  defaultValue={["info", "address", "emergency"]}
                  multiple
                  variant="separated"
                  classNames={{
                    control:
                      "bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg shadow-lg rounded-xl border border-gray-700",
                  }}
                >
                  <Accordion.Item value="info">
                    <Accordion.Control>
                      {t("basicTenantInfo")}
                    </Accordion.Control>
                    <Accordion.Panel className="bg-gray-800">
                      <div className="flex-col space-y-4">
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <TextInput
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={errors.name && `${errors?.name?.message}`}
                            withAsterisk
                            label={t("name")}
                            placeholder={t("name")}
                            {...register("name")}
                          />
                          <TextInput
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={errors.email && `${errors?.email?.message}`}
                            // withAsterisk
                            label={t("email")}
                            placeholder="email@example.com"
                            {...register("email")}
                          />
                        </div>
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          {/* <div className="flex w-full">
                            <Select
                              radius={"xs"}
                              searchable
                              nothingFound={
                                <div className="fle w-full justify-center items-center">
                                  <EmptyIcon />
                                </div>
                              }
                              onChange={(code) => {
                                code && setCode(code)
                              }}
                              classNames={{
                                input:
                                  "border border-gray-400/70 border-r-0 rounded rounded-r-none",
                              }}
                              value={code}
                              label={t("code")}
                              data={data?.map((item: any) => ({
                                label: `${item.name} (${item.dial_code})`,
                                value: item.dial_code,
                                key: item.name,
                              }))}
                              maxDropdownHeight={400}
                            />
                            <Input.Wrapper
                              id={id}
                              className="w-full"
                              label={t("phoneNumber")}
                              required
                              error={
                                errors.phoneNumber &&
                                `${errors?.phoneNumber?.message}`
                              }
                            >
                              <Input
                                classNames={{ input: "rounded-l-none" }}
                                component={InputMask}
                                mask={`${code} 999 999 999`}
                                id={id}
                                placeholder={t("phoneNumber")}
                                {...register("phoneNumber")}
                              />
                            </Input.Wrapper>
                          </div> */}
                          <TextInput
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={
                              errors?.phoneNumber &&
                              `${errors?.phoneNumber?.message}`
                            }
                            withAsterisk
                            label={t("phoneNumber")}
                            placeholder={t("phoneNumber")}
                            {...register("phoneNumber")}
                          />
                          <div className="px-4 w-full flex items-center justify-start">
                            <Radio.Group label={t("gender")}>
                              <Group>
                                <Radio
                                  value="male"
                                  label={t("male")}
                                  {...register("gender")}
                                />
                                <Radio
                                  value="female"
                                  label={t("female")}
                                  {...register("gender")}
                                />
                              </Group>

                              <span className="text-red-500 text-xs">
                                {errors.gender && errors.gender?.message}
                              </span>
                            </Radio.Group>
                          </div>
                        </div>

                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <div className="flex w-full md:w-[48%] space-x-4  justify-between">
                            <div className="w-full">
                              <Controller
                                control={control}
                                name="identification"
                                render={({ field }) => (
                                  <FileInput
                                    withAsterisk
                                    clearable
                                    className="w-full"
                                    error={
                                      errors.identification &&
                                      `${errors.identification?.message}`
                                    }
                                    label={t("identification")}
                                    //@ts-ignore
                                    placeholder={t("identification")}
                                    icon={<IconUpload size={14} />}
                                    {...field}
                                  />
                                )}
                              />
                              {tenant?.data?.minioIdentification && (
                                <span
                                  // target="_blank"
                                  // rel="noopener noreferrer"
                                  // href={tenant?.data?.minoioIdentification}
                                  // onClick={() => onViewFile(value?.file)}
                                  onClick={() => {
                                    setSelectedFile([
                                      tenant?.data
                                        ?.minioIdentification as string,
                                    ])
                                    fileOpen()
                                  }}
                                  className=" cursor-pointer text-primary font-bold my-2 hover:underline"
                                >
                                  {t("view")}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="flex w-full md:w-[48%] space-x-4  justify-between">
                            <div className="w-full">
                              <Controller
                                control={control}
                                name="document"
                                render={({ field }) => (
                                  <FileInput
                                    // withAsterisk
                                    multiple
                                    clearable
                                    className="w-full"
                                    error={
                                      errors.document &&
                                      `${errors.document?.message}`
                                    }
                                    label={t("document", { count: 2 })}
                                    //@ts-ignore
                                    placeholder={t("document", { count: 2 })}
                                    icon={<IconUpload size={14} />}
                                    {...field}
                                  />
                                )}
                              />
                              {tenant?.data?.minioDocuments &&
                                tenant?.data?.minioDocuments?.length > 0 && (
                                  <span
                                    // target="_blank"
                                    // rel="noopener noreferrer"
                                    // href={tenant?.data?.minoioIdentification}
                                    // onClick={() => onViewFile(value?.file)}
                                    onClick={() => {
                                      setSelectedFile(
                                        tenant?.data
                                          ?.minioDocuments as string[],
                                      )
                                      fileOpen()
                                    }}
                                    className=" cursor-pointer text-primary font-bold my-2 hover:underline"
                                  >
                                    View ({tenant?.data?.minioDocuments?.length}
                                    ) Files
                                  </span>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <div className="flex w-full md:w-full space-x-4  justify-between">
                            {currentUser?.role?.key &&
                              currentUser?.role?.key == "super_admin" && (
                                <Controller
                                  control={control}
                                  name="ownerId"
                                  render={({ field }) => (
                                    <Select
                                      classNames={{ label: "dark:text-white" }}
                                      className="w-full"
                                      onKeyDown={debounce(
                                        (event: any) =>
                                          setOwnerSearch(event?.target?.value),
                                        1000,
                                      )}
                                      searchable
                                      withAsterisk
                                      error={
                                        errors.ownerId &&
                                        `${errors?.ownerId?.message}`
                                      }
                                      clearable
                                      label={t("owner", { count: 1 })}
                                      placeholder={t("owner", { count: 1 })}
                                      data={_parsePropertyOwners()}
                                      {...field}
                                    />
                                  )}
                                />
                              )}

                            <TextInput
                              classNames={{ label: "dark:text-white" }}
                              className="w-full"
                              error={
                                errors?.tinNumber &&
                                `${errors?.tinNumber?.message}`
                              }
                              withAsterisk
                              label={t("tinNumber")}
                              placeholder={t("tinNumber")}
                              {...register("tinNumber")}
                            />
                          </div>
                        </div>
                      </div>
                    </Accordion.Panel>
                  </Accordion.Item>

                  <Accordion.Item value="address">
                    <Accordion.Control>{t("address")}</Accordion.Control>
                    <Accordion.Panel className="bg-gray-800">
                      <div className="flex-col space-y-4">
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <Controller
                            control={control}
                            name="address.country"
                            render={({ field }) => (
                              <Select
                                className="w-full"
                                withAsterisk
                                searchable
                                nothingFound={
                                  <div className="fle w-full justify-center items-center">
                                    <EmptyIcon />
                                  </div>
                                }
                                error={
                                  errors.address?.country &&
                                  `${errors?.address?.country?.message}`
                                }
                                radius={"xs"}
                                classNames={{
                                  label: "dark:text-white",
                                }}
                                label={t("country")}
                                data={getUniqueCountryOptions(worldCities)}
                                maxDropdownHeight={400}
                                {...field}
                              />
                            )}
                          />

                          <Controller
                            control={control}
                            name="address.city"
                            render={({ field }) => (
                              <Select
                                withAsterisk
                                className="w-full"
                                searchable
                                nothingFound={
                                  <div className="fle w-full justify-center items-center">
                                    <EmptyIcon />
                                  </div>
                                }
                                error={
                                  errors.address?.city &&
                                  `${errors?.address?.city?.message}`
                                }
                                radius={"xs"}
                                classNames={{
                                  label: "dark:text-white",
                                }}
                                defaultValue="United States"
                                label={t("city")}
                                placeholder={t("city")}
                                data={getCitiesByCountry(selectedCountry)}
                                maxDropdownHeight={400}
                                {...field}
                              />
                            )}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                        <TextInput
                          classNames={{ label: "dark:text-white" }}
                          className="w-full"
                          error={
                            errors.address?.subCity &&
                            `${errors?.address?.subCity.message}`
                          }
                          label={t("subCity")}
                          placeholder={t("subCity")}
                          {...register("address.subCity")}
                        />
                        <TextInput
                          classNames={{ label: "dark:text-white" }}
                          className="w-full"
                          error={
                            errors.address?.woreda &&
                            `${errors?.address?.woreda?.message}`
                          }
                          label={t("woreda")}
                          placeholder="7"
                          {...register("address.woreda")}
                        />
                      </div>
                      <div className="w-full md:w-[49%] flex space-x-4">
                        <TextInput
                          classNames={{ label: "dark:text-white" }}
                          className="w-full"
                          // withAsterisk
                          error={
                            errors.address?.houseNumber &&
                            `${errors?.address?.houseNumber?.message}`
                          }
                          label={t("houseNumber")}
                          placeholder={t("houseNumber")}
                          {...register("address.houseNumber")}
                        />
                      </div>
                    </Accordion.Panel>
                  </Accordion.Item>

                  <Accordion.Item value="emergency">
                    <Accordion.Control>
                      {t("emergencyContactPerson")}
                    </Accordion.Control>
                    <Accordion.Panel className="bg-gray-800">
                      <div className="flex-col space-y-4">
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <TextInput
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={
                              errors.emergencyContact?.name &&
                              `${errors?.emergencyContact?.name.message}`
                            }
                            label={t("name")}
                            withAsterisk
                            placeholder={t("name")}
                            {...register("emergencyContact.name")}
                          />
                          {/* <div className="flex w-full">
                            <Select
                              searchable
                              nothingFound={
                                <div className="fle w-full justify-center items-center">
                                  <EmptyIcon />
                                </div>
                              }
                              radius={"xs"}
                              onChange={(code) => {
                                code && setEmergencyCode(code)
                              }}
                              classNames={{
                                input:
                                  "border border-gray-400/70 border-r-0 rounded rounded-r-none",
                              }}
                              value={emergencyCode}
                              label={t("code")}
                              data={data?.map((item: any) => ({
                                label: `${item.name} (${item.dial_code})`,
                                value: item.dial_code,
                                key: item.name,
                              }))}
                              maxDropdownHeight={400}
                            />
                            <Input.Wrapper
                              id={id}
                              className="w-full"
                              label={t("phoneNumber")}
                              required
                              error={
                                errors.emergencyContact?.phoneNumber &&
                                `${errors?.emergencyContact?.phoneNumber.message}`
                              }
                            >
                              <Input
                                classNames={{ input: "rounded-l-none" }}
                                component={InputMask}
                                mask={`${emergencyCode} 999 999 999`}
                                id={id}
                                placeholder={t("phoneNumber")}
                                {...register("emergencyContact.phoneNumber")}
                              />
                            </Input.Wrapper>
                          </div> */}

                          <TextInput
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={
                              errors?.emergencyContact?.phoneNumber &&
                              `${errors?.emergencyContact?.phoneNumber?.message}`
                            }
                            withAsterisk
                            label={t("phoneNumber")}
                            placeholder={t("phoneNumber")}
                            {...register("emergencyContact.phoneNumber")}
                          />
                        </div>
                      </div>
                    </Accordion.Panel>
                  </Accordion.Item>
                </Accordion>

                <div className="w-full flex justify-end items-center">
                  <Group position="right" mt="xl">
                    {editMode === "new" && (
                      <>
                        <Button
                          classNames={{ label: "flex space-x-1 " }}
                          variant="default"
                          className="dark:text-white hover:bg-primary hover:dark:bg_dark_primary hover:text-white"
                          type="reset"
                          size="xs"
                        >
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="fill-current h-6"
                              viewBox="0 0 32 32"
                            >
                              <path d="M18.90625 4.09375C18.101563 4.09375 17.265625 4.367188 16.625 4.9375L16.625 4.96875L16.59375 5L4.90625 16.59375C3.695313 17.804688 3.703125 19.777344 4.84375 21.0625L4.875 21.09375L4.90625 21.09375L10.90625 27.09375C11.511719 27.699219 12.320313 27.992188 13.125 28L28 28L28 26L16.5 26L27 15.5C28.265625 14.234375 28.304688 12.210938 27.09375 11L21.09375 5C20.488281 4.394531 19.710938 4.09375 18.90625 4.09375 Z M 18.875 6.125C19.195313 6.125 19.492188 6.210938 19.6875 6.40625L25.6875 12.40625C26.074219 12.792969 26.128906 13.558594 25.59375 14.09375L20.5625 19.125L12.90625 11.46875L17.96875 6.4375L18 6.40625C18.253906 6.195313 18.570313 6.125 18.875 6.125 Z M 11.46875 12.90625L19.125 20.5625L14.03125 25.65625C14.019531 25.664063 14.011719 25.679688 14 25.6875C13.484375 26.117188 12.691406 26.066406 12.3125 25.6875L6.34375 19.75C6.328125 19.730469 6.328125 19.707031 6.3125 19.6875C5.902344 19.171875 5.9375 18.375 6.3125 18Z" />
                            </svg>
                          </span>
                          <span>{t("reset")}</span>
                        </Button>
                        <Button
                          variant="filled"
                          className="bg-primary text-white"
                          type="submit"
                          classNames={{ label: "flex space-x-1" }}
                          size={"xs"}
                          loading={newTenant.isLoading}
                        >
                          <span>
                            <IconDeviceFloppy size={22} strokeWidth={1.5} />
                          </span>
                          <span>{t("submit")}</span>
                        </Button>
                      </>
                    )}
                    {editMode === "detail" && (
                      <>
                        {(params?.type === "archived" &&
                          archivedTenant?.data?.deletedAt) ||
                        (params?.type === "active" &&
                          tenant?.data?.deletedAt) ? (
                          <>
                            <Confirmation
                              type={"danger"}
                              message={t("permanentDeleteMessage")}
                              onYes={() => deleteTenant(`${params?.id}`)}
                              header={t("permanentDeleteTitle")}
                            >
                              <Button
                                variant="filled"
                                loading={deleteResponse.isLoading}
                                className={`bg-danger text-white flex space-x-2 items-center`}
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <IconTrash size={20} strokeWidth={1.5} />
                                <span>{t("delete")}</span>{" "}
                              </Button>
                            </Confirmation>
                            <Confirmation
                              type={"notify"}
                              message={t("restoreMessage")}
                              onYes={() => restoreTenant(`${params?.id}`)}
                              header={t("restoreTitle")}
                            >
                              <Button
                                variant="filled"
                                loading={restoredTenant.isLoading}
                                className={`bg-green-500 text-white flex space-x-2 items-center`}
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <IconArrowBackUp size={20} strokeWidth={1.5} />
                                <span>{t("restore")}</span>
                              </Button>
                            </Confirmation>
                          </>
                        ) : (
                          <>
                            {" "}
                            <Confirmation
                              type={"notify"}
                              message={t("archiveMessage", {
                                model: t("tenant", { count: 1 }),
                              })}
                              header={t("archiveTitle", {
                                name: tenant?.data?.name,
                              })}
                              result={"single"}
                              resultRequired={true}
                              selectorLabel={t("selectAReason", {
                                model: t("tenant", { count: 1 }),
                              })}
                              labelDescription={t("archiveWhy", {
                                model: t("tenant", { count: 1 }),
                              })}
                              options={Constants(t)?.ArchiveReason?.map(
                                (reason) => {
                                  return { label: reason, value: reason }
                                },
                              )}
                              customInput={true}
                              yesText={t("archive")}
                              onYes={(reason: string) => {
                                archiveTenant({
                                  id: `${params.id}`,
                                  reason: reason,
                                })
                              }}
                            >
                              <Button
                                variant="filled"
                                loading={archiveResponse.isLoading}
                                className="bg-danger text-white"
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <span>
                                  <IconArchive size={22} strokeWidth={1.5} />
                                </span>
                                <span>{t("archive")}</span>
                              </Button>
                            </Confirmation>
                            <Confirmation
                              type={"notify"}
                              message={
                                <span>
                                  {t("activateMessage", {
                                    action: tenant?.data?.enabled
                                      ? t("deactivate")
                                      : t("activate"),
                                  })}
                                </span>
                              }
                              onYes={() => toggleStatus(`${params.id}`)}
                              header={t("activateTitle", {
                                action: tenant.data?.enabled
                                  ? t("deactivation")
                                  : t("activation"),
                              })}
                            >
                              <Button
                                variant="filled"
                                loading={toggleStatusResponse.isLoading}
                                className={`${
                                  tenant.data?.enabled
                                    ? " bg-danger"
                                    : "bg-green-500"
                                } text-white`}
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="fill-current h-6"
                                    viewBox="0 0 48 48"
                                  >
                                    <path d="M23.5 5C17.16639 5 12 10.16639 12 16.5C12 18.130861 12.341389 19.689962 12.957031 21.099609 A 1.50015 1.50015 0 1 0 15.707031 19.900391C15.252673 18.860038 15 17.713139 15 16.5C15 11.78761 18.78761 8 23.5 8C28.21239 8 32 11.78761 32 16.5C32 17.08427 31.94138 17.652314 31.830078 18.201172 A 1.50015 1.50015 0 1 0 34.769531 18.798828C34.92023 18.055686 35 17.28573 35 16.5C35 10.16639 29.83361 5 23.5 5 z M 23.5 12C21.032499 12 19 14.032499 19 16.5L19 25.759766L18.138672 25.404297C14.483804 23.900444 10.334734 26.436466 10.005859 30.375 A 1.50015 1.50015 0 0 0 10.693359 31.765625L19.957031 37.667969C20.601036 38.078718 21.151526 38.620029 21.576172 39.255859L23.033203 41.441406 A 1.50015 1.50015 0 0 0 23.035156 41.441406C23.803886 42.591886 25.189849 43.186167 26.554688 42.945312L31.882812 42.005859C33.603893 41.703285 34.998876 40.422039 35.449219 38.734375 A 1.50015 1.50015 0 0 0 35.451172 38.726562L37.832031 29.576172C38.653863 26.49462 36.64066 23.318721 33.501953 22.748047L28 21.748047L28 16.5C28 14.032499 25.967501 12 23.5 12 z M 23.5 15C24.346499 15 25 15.653501 25 16.5L25 23 A 1.50015 1.50015 0 0 0 26.232422 24.476562L32.964844 25.699219C34.424137 25.964545 35.315668 27.370273 34.933594 28.802734 A 1.50015 1.50015 0 0 0 34.929688 28.8125L32.550781 37.960938C32.399124 38.529274 31.940201 38.949356 31.363281 39.050781 A 1.50015 1.50015 0 0 0 31.363281 39.052734L26.033203 39.992188C25.834042 40.027338 25.642567 39.944908 25.529297 39.775391L24.072266 37.591797C23.417016 36.610136 22.565912 35.77367 21.570312 35.138672 A 1.50015 1.50015 0 0 0 21.568359 35.138672L13.251953 29.835938C13.814585 28.352335 15.413607 27.528548 16.996094 28.179688L19.929688 29.386719 A 1.50015 1.50015 0 0 0 22 28L22 16.5C22 15.653501 22.653501 15 23.5 15 z" />
                                  </svg>
                                </span>
                                {tenant?.data?.enabled ? (
                                  <span>{t("deactivate")}</span>
                                ) : (
                                  <span>{t("activate")}</span>
                                )}
                              </Button>
                            </Confirmation>
                            <Button
                              variant="filled"
                              className="bg-primary text-white"
                              type="submit"
                              classNames={{ label: "flex space-x-1" }}
                              size={"xs"}
                              loading={updateResponse.isLoading}
                            >
                              <span>
                                <IconDeviceFloppy size={22} strokeWidth={1.5} />
                              </span>
                              <span>{t("update")}</span>
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  </Group>
                </div>
              </form>
            </div>
          </Tabs.Panel>

          {/* <Tabs.Panel value="document" pt="xs">
              <div className="flex-col w-full space-y-4">
                <OwnerFileUploadComponent />
              </div>
            </Tabs.Panel> */}
        </Tabs>
      </>

      <PushNotificationComponent open={open} opened={opened} close={close} />
      <FileViewerModal
        open={fileOpen}
        close={fileClose}
        files={selectedFile}
        opened={fileOpened}
        fileType={t("identification")}
        fileNames={[]}
        remove={() => {}}
        removeLoading={false}
      />
    </ActivityLogWrapperComponent>
    // </div >
  )
}
